import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";
import store from "../store";
const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "Login" },
  },
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },

  //Sections routes
  {
    path: "/testimonials",
    name: "Testimonials",
    component: () => import("../views/Testimonials/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/clinics",
    name: "Clinics",
    component: () => import("../views/Clinics/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/clinics/create",
    name: "ClinicCreate",
    component: () => import("../views/Clinics/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/clinics/:id/edit",
    name: "ClinicEdit",
    component: () => import("../views/Clinics/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/testimonials/create",
    name: "TestimonialCreate",
    component: () => import("../views/Testimonials/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/testimonials/:id/edit",
    name: "TestimonialEdit",
    component: () => import("../views/Testimonials/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  //blog routes
  {
    path: "/blogs",
    name: "Blogs",
    component: () => import("../views/Blogs/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/blogs/create",
    name: "BlogCreate",
    component: () => import("../views/Blogs/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/blogs/:id/edit",
    name: "BlogEdit",
    component: () => import("../views/Blogs/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },

  //main services routes
  {
    path: "/main-services",
    name: "MainServices",
    component: () => import("../views/MainServices/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/main-services/create",
    name: "MainServiceCreate",
    component: () => import("../views/MainServices/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/main-services/:id/edit",
    name: "MainServiceEdit",
    component: () => import("../views/MainServices/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },

  //services routes
  {
    path: "/services",
    name: "Services",
    component: () => import("../views/Services/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/services/create",
    name: "ServiceCreate",
    component: () => import("../views/Services/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/services/:id/edit",
    name: "ServiceEdit",
    component: () => import("../views/Services/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },

  //doctors routes
  {
    path: "/doctors",
    name: "Doctors",
    component: () => import("../views/Doctors/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/doctors/create",
    name: "DoctorCreate",
    component: () => import("../views/Doctors/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/doctors/:id/edit",
    name: "DoctorEdit",
    component: () => import("../views/Doctors/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },

  //contacts routes
  {
    path: "/contacts",
    name: "Contact",
    component: () => import("../views/Contacts/ContactList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contacts/:id/show",
    name: "ContactShow",
    component: () => import("../views/Contacts/ContactShow.vue"),
    props: true,
    meta: { requiresAuth: true },
  },

  //appointments routes
  {
    path: "/appointments",
    name: "Appointments",
    component: () => import("../views/Appointments/List.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/appointments/:id/edit",
    name: "AppointmentEdit",
    component: () => import("../views/Appointments/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //careers routes
  {
    path: "/careers",
    name: "Careers",
    component: () => import("../views/Careers/List.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/careers/:id/edit",
    name: "CareerEdit",
    component: () => import("../views/Careers/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //home banners routes
  {
    path: "/home-banners",
    name: "Home Banners",
    component: () => import("../views/HomeBanners/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/home-banners/create",
    name: "HomeBannerCreate",
    component: () => import("../views/HomeBanners/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/home-banners/:id/edit",
    name: "HomeBannerEdit",
    component: () => import("../views/HomeBanners/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth;
  const isLoggedIn = store.getters["auth/isLoggedIn"];

  if (requiresAuth && !isLoggedIn) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
